<div class="general" *ngIf="isLoading" aria-hidden="true">
  <div class="general__group" *ngFor="let options of skeletonGroups">
    <span class="general__skeleton general__skeleton--label"></span>
    <div class="general__options">
      <span
        class="general__skeleton general__skeleton--option"
        *ngFor="let option of options"
      ></span>
    </div>
  </div>

  <span class="general__skeleton general__skeleton--preview"></span>

  <div class="general__actions">
    <span class="general__skeleton general__skeleton--save"></span>
  </div>
</div>

<div class="general__feedback" *ngIf="!isLoading && hasLoadError" role="alert">
  <ng-container *ngIf="isForbidden; else loadFailure">
    Você não tem acesso às preferências da AyA nesta organização.
  </ng-container>
  <ng-template #loadFailure>
    <p>Não foi possível carregar suas preferências. Nada foi alterado.</p>
    <button type="button" class="btn btn-outline-primary" (click)="load()">
      Tentar novamente
    </button>
  </ng-template>
</div>

<form
  class="general"
  *ngIf="!isLoading && !hasLoadError"
  [formGroup]="form"
  (ngSubmit)="save()"
>
  <fieldset class="general__group">
    <legend class="general__label">Emojis</legend>
    <div class="general__options">
      <label class="general__option" *ngFor="let option of emojiOptions">
        <input type="radio" formControlName="emojis" [value]="option.value" />
        <span>{{ option.label }}</span>
      </label>
    </div>
  </fieldset>

  <fieldset class="general__group">
    <legend class="general__label">Estilo de resposta</legend>
    <div class="general__options">
      <label
        class="general__option"
        *ngFor="let option of responseStyleOptions"
      >
        <input
          type="radio"
          formControlName="responseStyle"
          [value]="option.value"
        />
        <span>{{ option.label }}</span>
      </label>
    </div>
  </fieldset>

  <fieldset class="general__group">
    <legend class="general__label">Personalidade</legend>
    <div class="general__options">
      <label class="general__option" *ngFor="let option of personalityOptions">
        <input
          type="radio"
          formControlName="personality"
          [value]="option.value"
        />
        <span>{{ option.label }}</span>
      </label>
    </div>
  </fieldset>

  <div class="general__group" *ngIf="isCustom">
    <label class="general__label" for="general-custom-personality"
      >Instruções de comunicação</label
    >
    <textarea
      id="general-custom-personality"
      class="general__textarea"
      rows="4"
      formControlName="customPersonality"
      placeholder="Questione minhas hipóteses e sugira próximos passos práticos."
      aria-describedby="general-custom-personality-hint"
      [attr.aria-invalid]="customError ? 'true' : null"
    ></textarea>
    <div class="general__hint" id="general-custom-personality-hint">
      <span class="general__error" *ngIf="customError" role="alert">{{
        customError
      }}</span>
      <span class="general__counter">{{ customLength }}/{{ maxLength }}</span>
    </div>
  </div>

  <section class="general__preview" aria-label="Exemplo ilustrativo">
    <span class="general__preview-title">
      {{ isCustom ? 'Exemplo com tom neutro' : 'Exemplo ilustrativo' }}
    </span>
    <p>{{ previewText }}</p>
  </section>

  <div class="general__actions">
    <button
      type="submit"
      class="btn btn-primary general__save"
      [disabled]="!canSave"
    >
      <i class="fas fa-spinner fa-spin" *ngIf="isSaving" aria-hidden="true"></i>
      {{ isSaving ? 'Salvando…' : 'Salvar preferências' }}
    </button>
  </div>
</form>
